import { render, staticRenderFns } from "./ImportExportMenu.vue?vue&type=template&id=45211ac3"
import script from "./ImportExportMenu.vue?vue&type=script&lang=ts"
export * from "./ImportExportMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports